import React, { useEffect, useState } from "react";
import { useId } from "react";
import accessibility from "../../accessibility";
import tampuuriWindowObject from "../../tampuuriWindowObject";
import useHelpers from "../hooks/useHelpers.jsx";

function SelectRentals(props) {
  const { params, submitParams, svgObjects, addExchange, translateLabels } =
    props;
  const [rentalTypes, setRentalTypes] = useState({});
  const [state, setState] = useState({});
  const { translate, translatei18nDB, getRentalTypes } = tampuuriWindowObject();
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const { id } = useId();
  const { checkForChecked } = useHelpers();

  useEffect(() => {
    setState({ loading: true });
    const rentalData = getRentalTypes();
    setRentalTypes(rentalData);
    setState({ loading: false });
  }, []);

  const addRentalType = (value) => {
    let currentRentalTypes = [...params?.rentalTypes];
    let accessibilitySpeakerLabel = "";

    if (checkForChecked(value, currentRentalTypes)) {
      currentRentalTypes = currentRentalTypes.filter((e) => e !== value);
      accessibilitySpeakerLabel =
        translate("Remove") + " " + translatei18nDB(value);
    } else {
      currentRentalTypes.push(value);
      accessibilitySpeakerLabel =
        translate("Add") + " " + translatei18nDB(value);
    }

    submitParams({ rentalTypes: currentRentalTypes });
    announceMessage(globalAccessibilitySpeakerId, accessibilitySpeakerLabel);
  };

  const addForExchangeStudents = (forExchangeStudents) => {
    const message = window.hoasTampuuri["Hae vaihto-opiskelijoiden kohteista"];
    submitParams({ exchangeStudents: forExchangeStudents });
    announceMessage(globalAccessibilitySpeakerId, message);
  };

  if (state?.loading) {
    return;
  }

  return (
    <div className="rentals" role="group" aria-labelledby={id}>
      <legend id={id}>{translate("Asuntotyypit")}</legend>
      <div className="filter-buttons-container">
        {Object.entries(rentalTypes).map(([key, value], index) => {
          return (
            <button
              className={
                checkForChecked(value, params?.rentalTypes) ? "active" : ""
              }
              key={"first_" + value + index}
              onClick={(e) => {
                e.preventDefault();
                addRentalType(value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  addRentalType(value);
                }
              }}
            >
              {translateLabels
                ? translateLabels(value)
                : translatei18nDB(value)}{" "}
              {checkForChecked(value, params?.rentalTypes) ? (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: svgObjects?.close,
                    }}
                  />
                  <span className="sr-only">
                    {translate("Selected") + " " + translatei18nDB(value)}
                  </span>
                </>
              ) : (
                <span className="plus" aria-hidden="true">
                  +
                </span>
              )}
            </button>
          );
        })}

        {addExchange && (
          <button
            className={params?.exchangeStudents ? "active" : ""}
            key={"first_" + "for_exchange" + Object.entries(rentalTypes).length}
            onClick={(e) => {
              e.preventDefault();
              addForExchangeStudents(!params?.exchangeStudents);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addForExchangeStudents(!params?.exchangeStudents);
              }
            }}
          >
            {translatei18nDB(window.hoasTampuuri["Vaihto-opiskelija-asunto"])}{" "}
            {params?.exchangeStudents ? (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: svgObjects?.close,
                  }}
                />
                <span className="sr-only">{translate("Selected")}</span>
              </>
            ) : (
              <span className="plus" aria-hidden="true">
                +
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default SelectRentals;
